// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD_JGpRAyz4qcTyY7NvbxhcCWKJ__-Hahg',
    authDomain: 'talenttoute.firebaseapp.com',
    databaseURL: 'https://talenttoute.firebaseio.com',
    projectId: 'talenttoute',
    storageBucket: 'talenttoute.appspot.com',
    messagingSenderId: '224844697828',
    appId: '1:224844697828:web:e19aa1e119340ac1a11cf1',
    measurementId: 'G-FWNV1NVFT7',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
